<template>
	<div class="submit-button-group">
		<div class="col-xs-6 btn-right">
			<buttonType
				:label=btnPrimaryText
				:id="btnPrimaryId"
				:disabled=disabled
				:buttonClick="primaryButtonClick"
				:loading="loading"/>
		</div>
		<div class="col-xs-6 btn-left">
			<buttonType
				:btnPrimary=true
				:label=btnSecondaryText
				:id="btnSecondaryId"
				:buttonClick="secondaryButtonClick"
				:btnHide="secondaryButtonHide"
				:loading="secondaryButtonLoading"/>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
import buttonType from './button';

export default {
	name: 'multiButtons',
	description: 'It provide multi or single button set for Arena theme',
	components: {
		buttonType
	},
	props: {
		btnPrimaryText: {
			type: String,
			default: '',
			note: 'Primary button label'
		},
		btnSecondaryText: {
			type: String,
			default: '',
			note: 'Secondary button label'
		},
		btnPrimaryId: {
			type: String,
			default: '',
			note: 'Set primary button ID'
		},
		btnSecondaryId: {
			type: String,
			default: '',
			note: 'Set secondary button ID'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Assign disabled state if needed'
		},
		primaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to primary button'
		},
		secondaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to secondary button'
		},
		secondaryButtonHide: {
			type: Boolean,
			default: false,
			note: 'Hide option for secondary button'
		},
		secondaryButtonLoading: {
			type: Boolean,
			default: false,
			note: 'Show loading to secondary button if needed'
		},
		loading: {
			type: Boolean,
			default: false,
			note: 'Loading states for Primary button'
		},
	}
};
</script>

<style lang="less" scoped>
	.submit-button-group {
		margin-top: 5px;
	}
	.btn-left {
		padding-right:5px;
		float: left;
	}
	.btn-right {
		padding-left:5px;
		float: right;
	}
	.btn-primary {
		color: #fff;
		background-color: #4d4d4d;
		border-color: #4d4d4d;
		&:hover {
			border-color: #666;
			background-color: #666
		}
		&:focus {
			color: #666;
			background-color: #404040;
			border-color: #404040;
		}
	}
	@media (max-width: 479px) {
		.btn-left,
		.btn-right{
			padding: 0;
			float: none;
		}
		.btn-left {
			margin-top: 10px;
		}
	}
</style>
